import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  HostListener,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { XUXDrawerSidebarService } from '../../services/xux-drawer-sidebar.service';
import { rx, Subscription } from '@shared/rx';

@Component({
  selector: 'xux-drawer-container',
  templateUrl: './xux-drawer-container.component.html',
  styleUrls: ['./xux-drawer-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XUXDrawerContainerComponent implements OnInit, OnDestroy {
  @HostBinding('class.sidebar-open')
  public sidebarOpen: boolean = true;

  @HostBinding('class.sidebar-closed')
  public get sidebarClosed(): boolean {
    return !this.sidebarOpen;
  }

  private subs: Subscription[] = [];

  public constructor(
    private readonly router: Router,
    private readonly drawerSidebarService: XUXDrawerSidebarService,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.subs.push(
      this.router.events
        .pipe(rx.filter((event) => event instanceof NavigationStart))
        .subscribe(() => this.drawerSidebarService.closeOnMobile()),

      this.drawerSidebarService.slideState$.subscribe((state) => {
        this.sidebarOpen = state === 'open';
        this.changeDetectorRef.markForCheck();
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  public onBackdropClicked(): void {
    this.drawerSidebarService.close();
  }

  @HostListener('window:resize')
  public onresize(): void {
    this.drawerSidebarService.closeOnMobile();
  }
}
